<template>
  <div>
    <groups ref="groups" :pageType="pageType" />
    <user-modal @hasUpdate="handleUpdate" />
    <machine-user-modal @hasUpdate="handleUpdate" />
    <group-modal @hasUpdate="handleUpdate">
      <template v-slot:isEditable>
        <b-tab title="Add User">
          <new-user-form :group="selectedGroup" @hasUpdate="handleUpdate" />
        </b-tab>
      </template>
    </group-modal>
  </div>
</template>

<script>
import MachineUserModal from "../components/Modals/MachineUserModal.vue";
import UserModal from "../components/Modals/UserModal.vue";
import GroupModal from "../components/Modals/GroupModal.vue";
import Groups from "../components/Groups.vue";
import NewUserForm from "../components/Forms/NewUserForm.vue";
import config from "../constants/config";
import { mapGetters } from "vuex";

export default {
  components: {
    Groups,
    MachineUserModal,
    UserModal,
    GroupModal,
    NewUserForm
  },
  methods: {
    handleUpdate() {
      this.$refs.groups.fetchGroups();
    }
  },
  computed: {
    ...mapGetters("group", ["selectedGroup"]),
    pageType() {
      return config.USERS_PAGE;
    }
  }
};
</script>
